// @flow

import {Tag} from 'docs/util';
import schema from 'docs/markdoc/schema';
import type {
  MarkdocTagRegistration,
  MarkdocNodeRegistration,
} from 'docs/markdoc';

export const MarkdocTagReference: MarkdocTagRegistration = {
  tag: 'markdoc-tag-reference',
  component: 'MarkdocTagReference',
  render(node, config) {
    // It'd be cleaner to do this in React instead of a tag render function
    // but we need the heading in the render tree so it shows up in the TOC

    const tags = Object.entries(schema.tags)
      .filter(([id: string, _]) => !id.includes('markdoc'))
      .flatMap(([id: string, tag: MarkdocTagRegistration]) => [
        new Tag('Heading', {level: 3, anchored: true, id, toc: id}, [id]),
        new Tag(this.tag, {tag, tagName: id}),
        new Tag('MarkdocAttributeReference', {tag}),
        new Tag('MarkdocTagExternalLinks', {tagSchema: tag, tagName: id}),
      ]);

    const nodes = Object.entries(schema.nodes)
      .filter(([id: string, _]) => !id.includes('document'))
      .flatMap(([id: string, schemaNode: MarkdocNodeRegistration]) => [
        new Tag('Heading', {level: 3, anchored: true, id, toc: id}, [id]),
        new Tag(this.tag, {tag: schemaNode, tagName: id}),
        new Tag('MarkdocAttributeReference', {tag: schemaNode}),
      ]);

    return [...tags, ...nodes];
  },
};
